import register from "../utils/errorHandler/register"

export default function getMessageFromErrorCode(errorCode: string, err: PBError | GraphError) {
  return register.getMessage(errorCode, err)
}
